import * as React from "react";
import { SVGProps } from "react";

const SvgSettingsStorage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 31 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22 0H2C.5 0 0 .5 0 1.985v21.718A.3.3 0 0 0 .3 24h3.4a.3.3 0 0 0 .3-.297V5.188C4 4.534 4.548 4 5.223 4h13.555C19.453 4 20 4.534 20 5.188v9.27a9.997 9.997 0 0 1 4-.409V1.985C24 .5 23.5 0 22 0Zm-8.542 21a9.953 9.953 0 0 0-.409 2H6.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h6.958Zm1.541-3a9.989 9.989 0 0 0-1.167 2H6.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H15Zm2.978-2.65c-.779.455-1.491 1.01-2.118 1.65H6.5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .477.35ZM6 12.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1Zm0-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-1ZM6.5 6a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h11a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-11ZM26.456 24c0 1.84-1.547 3.333-3.456 3.333S19.544 25.841 19.544 24c0-1.84 1.547-3.333 3.456-3.333s3.456 1.492 3.456 3.333Zm-1.382 0c0 1.105-.929 2-2.074 2-1.145 0-2.074-.895-2.074-2s.929-2 2.074-2c1.145 0 2.074.895 2.074 2Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M29.154 23.115 31 21.88a7.793 7.793 0 0 0-.737-1.746l-.152-.253a8.08 8.08 0 0 0-1.209-1.501l-2.031.924a6.27 6.27 0 0 0-1.588-.886l-.187-2.16a8.623 8.623 0 0 0-3.847-.079l-.279 2.149a6.28 6.28 0 0 0-1.84.975l-2.032-.923a8.082 8.082 0 0 0-1.21 1.5l-.151.254a7.81 7.81 0 0 0-.636 1.419l1.79 1.307a5.82 5.82 0 0 0-.045 2.026L15 26.12c.175.614.424 1.2.737 1.746l.152.253c.28.448.603.868.965 1.253l2.068-.842c.528.443 1.134.8 1.796 1.052l.186 2.16c.67.168 1.372.257 2.096.257s1.426-.09 2.096-.258l.186-2.159c.577-.22 1.111-.52 1.589-.885l2.031.923a8.078 8.078 0 0 0 1.21-1.501l.15-.253A7.79 7.79 0 0 0 31 26.121l-1.846-1.236a5.843 5.843 0 0 0 0-1.77ZM27.147 24c0 2.21-1.856 4-4.147 4-2.29 0-4.147-1.79-4.147-4s1.856-4 4.147-4c2.29 0 4.147 1.79 4.147 4Z"
      fill="#fff"
    />
  </svg>
);

export default SvgSettingsStorage;
